<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Manage Group"
              bc1="App"
              bc2="Privilege"
              bc3="Manage Group"
              path="privilege"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Groups</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal">
                    <div class="row">
                      <h6 class="section-label mx-1 mb-2">Groups</h6>
                      <div class="col-12 mb-2" >
<!--                        <h5 class="mb-1">{{ feature.name }}</h5>-->
                        <div class="custom-control custom-switch mb-1" v-for="(feature,index) in featureList" :key="index">
                          <input :id="index" type="checkbox" v-if="typeof(feature.checked) != 'undefined'"
                                 class="custom-control-input" v-model="feature.checked" />
                          <label :class="typeof(feature.checked) != 'undefined' ? 'custom-control-label':''" :for="index">
                            {{ feature.name }}
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-9 d-flex pb-2 px-2">
                        <button
                            type="button"
                            class="btn btn-primary mr-1 d-flex "
                            @click="sendCall"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save Changes
                        </button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'privilege' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  mounted() {
    this.getAllRoles()


  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Merchant Staff'},
        {name: 'Permissions'},
      ],
      loader: false,
      featureList: [],
      tmpLIst:[],
      alreadyCheckedRoles: {},
      loading: false,
      size: "10px",

    }
  },
  methods: {
    sendCall() {

      this.$validator.validateAll().then(valid => {
        if (valid) {

          this.loading = true;
          let rolesId = []
          //extracting ids to send with the request
          this.featureList.forEach(eachFeature => {
            if (eachFeature.checked) {
              rolesId.push(eachFeature.id)
            }
          })

          // let data = new FormData();
          // data.append("application", "android");
          // data.append("applicationVersion", "1.33");
          // data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          // data.append("deviceDetail", "android s4 etc");
          // data.append("latitude", "");
          // data.append("longitude", "");
          //
          // data.append("roleId", JSON.stringify(rolesId));
          // data.append("privilegeId", this.privilegeId);

          let data = {
            roleId : JSON.stringify(rolesId),
            privilegeId : this.privilegeId,
          }
          this.makeRequest("post", "v1/add-role-privilege", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.loading = false;
                    if (callResponse.response.data.data) {
                      // let responseData = callResponse.response.data.data;
                      // let storeData = this.$store.getters.getByKey("privilege");
                      // if (typeof storeData.firstPageData != "undefined") {
                      //   storeData.firstPageData.data.unshift(responseData);
                      //   storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                      //   if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                      //     storeData.firstPageData.data.pop();
                      //   }
                      //   delete storeData.otherPageData;
                      //   storeData.key = "privilege";
                      //   this.$store.dispatch("set", storeData);
                      // }
                      this.$router.push({
                        name: "privilege",
                        // params: { add: true }
                      });
                    }
                  } else if (code == 400) {
                    this.loading = false;
                  }
                }
              }
          );
        }
      });


    },
    getAllRoles() {
      let type = [2, 3];
      let requestData = {
        flag: "all",
        type: JSON.stringify(type)
      }
      this.makeRequest('post', 'v1/get-role', requestData, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.tmpLIst = callResponse.response.data.data
            this.getAlreadySelectedRoles()
          }
        }

      });
    },
    getAlreadySelectedRoles() {
      let privileId = this.$store.getters.getByKey("privilegeGroupUpdate").row
          .id;
      this.makeRequest("post", "v1/get-role-privilege", {
        flag: "all",
        privilegeId: privileId
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            this.privilegeId = callResponse.response.data.data[0].id;
            let data = callResponse.response.data.data[0].roles;
            data.forEach(v => {
              this.alreadyCheckedRoles[v.role_id] = true
            })


            this.tmpLIst.forEach(eachFeature => {
              if (typeof (this.alreadyCheckedRoles[eachFeature.id]) != 'undefined') {
                eachFeature.checked = true
              } else {
                eachFeature.checked = false
              }

            })
            this.featureList = this.tmpLIst


          }
        }
      });
    },
  },
}
</script>

